<template>
  <div class="personal-dialog">
    <div class="vip-info" @click="jumpVip">
      <img :src="userInfo.vip_bg" alt="" class="vip-bg">
      <div class="vip-content" :class="{'show-vip': userInfo.vip_type}">
        <div class="vip-title">
          {{userInfo.vip_title}} <svg-icon name="arrow_right" class="vip-arrow"></svg-icon>
        </div>
        <div class="date">
          {{userInfo.vip_end_date}}
        </div>
      </div>
    </div>
    <div class="audio-container">
      <div class="audio-left" @click="jumpVip">
        <div class="audio-title">可用配音</div>
        <div><b>{{userInfo.total}}</b>条</div>
      </div>
      <div class="right" @click="jumpVip('bag')">
        <SuperAudioBag></SuperAudioBag>
      </div>
    </div>
    <div class="list">
      <div class="item" @click="jumpVip">
        <div class="left">
            <svg-icon name="wallet"></svg-icon>
            我的钱包 
        </div>
        <div class="right">
            <b>{{walletInfo.balance}}</b>元
            <svg-icon name="arrow_right"></svg-icon>
        </div>
      </div>
      <div class="item" @click="jumpList">
        <div class="left">
            <svg-icon name="consume"></svg-icon>
            消费记录 
        </div>
        <div class="right">
            <svg-icon name="arrow_right"></svg-icon>
        </div>
      </div>
      <!-- <div class="item">
        <div class="left">
            <svg-icon name="key"></svg-icon>
            激活码 
        </div>
        <div class="right">
            <svg-icon name="arrow_right"></svg-icon>
        </div>
      </div> -->
      <div class="item" @click="quit">
        <div class="left">
            <svg-icon name="quit"></svg-icon>
            退出登录 
        </div>
        <div class="right">
            <svg-icon name="arrow_right"></svg-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SuperAudioBag from './super-audio-bag.vue'

export default {
  name: 'personal-dialog',
  props: {
    msg: String,
    userInfo: Object
  },
  data() {
    return {
      balance: 0
    }
  },
  components: {
    SuperAudioBag
  },
  computed: {
    walletInfo () {
      return this.$store.state.global.walletInfo
    }
  },
  created () {
    this.$store.dispatch('global/setWalletInfo')
  },
  methods: {
    jumpVip (param) {
      console.log(param, 'param')
      if (this.$route.path !== '/personal/vip') {
        this.$router.push({path: '/personal/vip'});
      } 
      if (param === 'bag') {
        this.$store.dispatch('global/setBagFlag', true)
      }
      this.$emit('hideDialog')
    },
    jumpList () {
      this.$router.push({path: '/personal/list'});
      this.$emit('hideDialog')
    },
    quit () {
      this.$store.dispatch('global/setToken', '')
      this.$store.dispatch('global/setUserInfo', '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.personal-dialog {
  position: absolute;
  top: 80px;
  width: 240px;
  right: 0;
  padding: 16px 16px 6px;
  box-sizing: border-box;
  background: #FFFFFF;
  box-shadow: 10px 10px 9px 0px rgba(204, 204, 204, 0.6);
  border-radius: 4px;
  border: 1px solid #EEEEEE;
  font-size: 14px;
  b {
    color: #FA6400;
    margin-right: 3px;
  }
  .vip-info {
    position: relative;
    cursor: pointer;
    .vip-bg {
      width: 100%;
    }
    .vip-content {
      position: absolute;
      top: 20px;
      left: 12px;
      font-size: 18px;
      // color: #A6682C;
      .vip-title {
        display: flex;
        align-items: center;
        height: 22px;
        .svg-icon {
          // color: #A6682C;
          width: 18px;
          height: 18px;
        }
      }
      .date {
        // color: #999999;
        font-size: 12px;
        margin-top: 15px;
      }
      // &.show-vip {
      //   color: #A6682C;
      //   .svg-icon {
      //     color: #A6682C;
      //   }
      //   .date {
      //     color: #A6682C;
      //   }
      // }
    }
  }
  .audio-container {
    padding: 15px 0;
    border-bottom: 1px solid #EEEEEE;
    color: #999999;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .audio-left {
      cursor: pointer;
    }
    .audio-title {
      margin-bottom: 3px;
    }
  }
  .list {
    color: #555555;
    .item {
      display: flex;
      justify-content: space-between;
      padding: 15px 0;
      cursor: pointer;
      .svg-icon {
        width: 16px;
        height: 16px;
      }
      .left {
        display: flex;
        align-items: center;
        .svg-icon {
          margin-right: 15px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        color: #999;
        b {
          color: #FA6400;
          margin-right: 3px;
        }
      }
    }
  }
}
</style>
